import type { Editor } from '@tiptap/core';
import { NodePos } from '@tiptap/core';
import type { Node_Type } from 'ricos-schema';

export const findNodeClosestToSelection = (editor: Editor, nodeType: Node_Type) => {
  const { selection } = editor.state;

  const startNodePos = new NodePos(selection.$from, editor);
  const startNode = startNodePos.closest(nodeType);

  if (!startNode?.pos) {
    return null;
  }

  const isRangeSelection = selection.$from.pos !== selection.$to.pos;
  if (!isRangeSelection) {
    return startNode;
  }

  const endNodePos = new NodePos(selection.$to, editor);
  const endNode = endNodePos.closest(nodeType);

  if (!endNode?.pos || endNode.pos !== startNode.pos) {
    return null;
  }

  return startNode;
};
